import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { InicioService } from '../../services/inicio.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit{
  public rutas = inject(Router);
  public service = inject(InicioService);

  user: any;
  logeo: boolean = false;
  token: string = ''

  ngOnInit(): void {
    if (typeof window !== 'undefined' && !!localStorage.getItem('token')) {
      const storedUser = localStorage.getItem('usuSesion');
      if (storedUser != null) {
        this.user = JSON.parse(storedUser);
        this.service.updateLogeo(this.user);
      } else {
        // Si no hay usuario almacenado, realizar la lógica de autenticación
        this.user = null;
        this.service.updateLogeo(this.user);
        //console.log('no hay usuario')
      }
    }
    //console.log('no hay usuario: ', this.user)
    this.service.user$.subscribe(user => {
      this.user = user;
    });
  }

  catalogo(){
    //alert('asdasd')
    if(this.user){
      this.rutas.navigate(['/panel-admin/catalago_admin']);
    }
    else{
      this.rutas.navigate(['/catalago']);
    }

  }

}
